import LabelModalHeader from './LabelModalHeader';

export default LabelModalHeader;
